'use strict';

const ritualsFormHelper = require('./rituals-form-helper');
const lazyLoadHelper = require('./rituals-lazyload-helper');
const equalHeight = require('./modules/helpers/equalHeight');
const isMobileWidth = require('./modules/util/isMobileWidth');

/**
 * @description Adds the anime-block classes to all elements listed in the element array
 **/
function prepareAnimBlocks() {
    // list of element that should be converted to an anim-block
    const allowedClasses = [
        '.content-banner',
        '.two-tile-vertical'
    ];

    // list of classes that should not be converted an anim-block
    const skipClasses = [
        '.js-anim-block',
        '.two-tile-vertical-small'
    ];

    $.each(allowedClasses, function(idx, val) {
        $(val).each(function(i, v) {
            const shouldSkip = $(v).is(skipClasses.join(','));
            const containsVideo = $(v).find('.js-vimeo-player').length > 0;

            if (!shouldSkip && !containsVideo) {
                $(v).addClass('js-anim-block not-in-viewport');
            }
        });
    });
}

/**
 * @private
 * @function
 * @description Checks and gets the anchor id from the url and scrolls to that block
 */
function jumpToAnchor(anchorID) {
    if (!anchorID) {
        return;
    }

    const hasTrigger = anchorID.indexOf('trigger') === 0;
    const id = hasTrigger ? 'product-filter-grid' : anchorID;
    const $scrollToEl = $('[data-anchor-id=' + id + ']');
    const $triggerEl = $('[data-anchor-id=' + anchorID + ']');

    if ($scrollToEl.length > 0) {
        $('html, body').animate({
            scrollTop: $scrollToEl.last().offset().top
        }, 800, function(e) {
            if (hasTrigger) {
                e.preventDefault();
                const currentUrl = window.location.href;
                $triggerEl.trigger('click');
                window.location.href = currentUrl;
            }
        });
    }
}

/**
 * @description Initializes custom scrollbar
 **/
function initCustomScrollbarEvents() {
    $('.js-custom-scrollbar').mCustomScrollbar();
}

/**
 * @description Makes footer positioned at the bottom of the page
 **/
function bottomFooterPosition() {
    const $fullHeightPage = $('.js-page-fullheight');
    const footerHeight = $('.footer').outerHeight();

    if ($fullHeightPage.length) {
        $fullHeightPage.css('padding-bottom', footerHeight);
    }
}

/**
 * @description Equal height of concept highlight block
 **/
function conceptHighlightHeight() {
    $('.js-concept-highlight-block').each(function () {
        const $this = $(this);
        const $mediaHolder = $this.find('.js-concept-highlight-media');
        const $textHolder = $this.find('.js-concept-highlight-text');
        const $col = $this.find('.js-concept-highlight-col');

        if (!$this.parents('.js-alternative-code-example').length) {
            equalHeight($mediaHolder, 3);
            equalHeight($textHolder, 3);

            if (!$col.hasClass('visible')) {
                $col.addClass('visible');
            }
        }
    });
}

function appHighlightEqualHeight() {
    const $appHightlightEqualDiv = $('.js-narrow-highlight-media-equal');

    if (!$appHightlightEqualDiv.length){
        return;
    }

    if (isMobileWidth()){
        $appHightlightEqualDiv.css('height','');
        return;
    }

    equalHeight($appHightlightEqualDiv, 2);
}

$(window).on('load resize', function () {
    appHighlightEqualHeight();
});

const ritualsStyles = {
    initInputStyles: function() {
        ritualsFormHelper.init();
    },
    prepareAnimBlocks: function() {
        prepareAnimBlocks();
    },
    initLazyLoad: function(){
        lazyLoadHelper.init();
    },
    jumpToAnchor: function(anchorID) {
        jumpToAnchor(anchorID);
    },
    initCustomScrollbar: function () {
        initCustomScrollbarEvents();
    },
    initBottomFooterPosition: function () {
        bottomFooterPosition();
    },
    initConceptHighlightHeight: function () {
        conceptHighlightHeight();
    },
    initAppHighlightEqualHeight: function () {
        appHighlightEqualHeight();
    }
};

module.exports = ritualsStyles;
